<ng-container *ngIf="feedbacks$ | async as feedbacks">
  <ul *ngFor="let feedback of feedbacks">
    <li>
      <strong>{{ feedback.assistantFullName }}:</strong>
      {{ feedback.content | extractFeedbackMessage }}
      <ion-button fill="clear" *ngIf="allowRemoveFeedback && currentUser?.isAdmin()" (click)="removeFeedback(feedback)">
        <ion-icon icon="close" color="danger"></ion-icon>
      </ion-button>
    </li>
  </ul>
</ng-container>
